import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {DailyReport} from '../../../types/data.types';
import {DailyReportsService} from '../../../services/daily-reports.service';
import {AuthenticationService} from '../../../services/authentication.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'daily-reports-modal',
    templateUrl: './daily-reports-modal.component.html',
    styleUrls: ['./daily-reports-modal.component.scss']
})
export class DailyReportsModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: DailyReport = new DailyReport();
    disabledSubmit = false;
    dateFrom: string = (new Date).toISOString();
    timeFrom = DailyReportsModalComponent.parseTime((new Date()).toISOString());
    dateTo: string = (new Date).toISOString();
    timeTo = DailyReportsModalComponent.parseTime((new Date()).toISOString());

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public dailyReportsService: DailyReportsService,
        private authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        this.initTimePicker();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initTimePicker() {
        $('#timepickerfrom').timepicker().on('changeTime.timepicker', e => this.timeFrom = e.time.value);
        $('#timepickerto').timepicker().on('changeTime.timepicker', e => this.timeTo = e.time.value);
    }

    openTimepicker(id): void {
        $(`#${id}`).timepicker('showWidget');
    }

    initData() {
        if (this.dailyReportsService.dailyReportInDailyReportsModal) {
            this.data = this.dailyReportsService.dailyReportInDailyReportsModal;
            this.dateFrom = this.data.startDate;
            this.timeFrom = DailyReportsModalComponent.parseTime(this.data.startDate);
            this.dateTo = this.data.endDate;
            this.timeTo = DailyReportsModalComponent.parseTime(this.data.endDate);
            // this.getSuites(this.data.buildingId, this.data.suiteId);
        } else {
            const b = this.urlService.queryParams['building'];
            if (b) {
                this.data.buildingId = b;
                // this.getSuites(this.data.buildingId);
            }

            if (this.dailyReportsService.buildings.length === 1) {
                this.data.buildingId = this.dailyReportsService.buildings[0].id;
                // this.getSuites(this.data.buildingId);
            }
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.dailyReportsService.isDailyReportsModalShow = false;
                    this.dailyReportsService.dailyReportInDailyReportsModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.dailyReportsService.isDailyReportsModalShow = false;
            this.dailyReportsService.dailyReportInDailyReportsModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.buildingId) toastr.warning('Building should not be blank.');
            // if (!form.value.status) toastr.warning('Status should not be blank.');
            if (!form.value.relieved) toastr.warning('Relieved should not be blank.');
            if (!form.value.relievedBy) toastr.warning('Relieved By should not be blank.');
            if (!form.value.dateFrom) toastr.warning('Date From should not be blank.');
            if (!form.value.dateTo) toastr.warning('Date To should not be blank.');
            return;
        }
        const building = this.dailyReportsService.buildings.find((item) => item.id == form.value.buildingId);

        if (new Date(form.value.dateFrom) > new Date(form.value.dateTo)) {
            toastr.warning('End Date should not be earlier than Start Date.');
            return;
        }
        if (!form.value.relieved.trim().length) {
            toastr.warning('Relieved should not be blank.');
            return;
        }
        if (!form.value.relievedBy.trim().length) {
            toastr.warning('Relieved By should not be blank.');
            return;
        }

        const data: any = {
            building: {
                bdId: form.value.buildingId,
                name: building ? building.name : null,
                timezone: building && building.timeZone ? building.timeZone.value : undefined,
            },
            status:         'draft',
            relieved:       form.value.relieved,
            relievedBy:     form.value.relievedBy,
            startDate:        this.getDateTimeFromForm('From'),
            endDate:        this.getDateTimeFromForm('To'),
            createdBy: {
                fullName: this.authService.user.fullName,
                email: this.authService.user.email
            }
        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.api.patch('domainDailyReports', `/v1/daily_report/${this.data.id}.json`, data).subscribe(
                () => this.updateView('Daily Report successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Edit Daily Report failed');
                }
            );
        } else {
            this.api.post('domainDailyReports', '/v1/daily_report.json', data).subscribe(
                () => this.updateView('Daily Report successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Create Daily Report failed');
                }
            );
        }
    }

    getDateTimeFromForm(fromORto: string): Date {
        const date = new Date(this.form.value['date' + fromORto]);
        const time = this.form.value['time' + fromORto];
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return moment(date).format('YYYY-MM-DD HH:mm');
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.dailyReportsService.getData();
        this.form.reset();
        this.hideModal();
    }

    onStartDateChange(): void {
        if(new Date(this.dateFrom) > new Date(this.dateTo)) {
            this.dateTo = null;
            this.form.value.dateTo = null;
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-modal/daily-reports-modal.component.ts